export default "__VITE_ASSET__Deu8yUKG__"